import React from 'react';
import '../../styles/partners.css';

const LogoMarquee = ({ items = [] }) => {
    // Duplicate items to ensure smooth infinite loop
    const displayItems = [...items, ...items, ...items];

    return (
        <div className="marquee-container">
            <div className="marquee-content">
                {displayItems.map((item, index) => (
                    <div key={index} className="marquee-item">
                        {item.image ? (
                            <img src={item.image} alt={item.name} className="marquee-logo" />
                        ) : (
                            <span className="marquee-text">{item.name}</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LogoMarquee;
